import React from 'react'
import ProductCard from './ProductCard'

function PurchaseSeparately({ filters }) {
    return (
        <>
            <h2 className="normal-case text-white font-bold text-4xl text-center py-8">Purchase Seperately</h2>
            <div className="grid grid-cols-2 gap-5 mb-16 lg:flex lg:justify-center">
            {filters.map((filter) => {
                return (<ProductCard key={filter.id} product={filter} extraClasses=""/>)
            })}
            </div>
        </>
    )
}

export default PurchaseSeparately